module.exports = __webpack_public_path__ + "img/3.3智能制造-4.d6382e31.png";